import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_PROMOCODE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemPromoCodeMaybe = props => {
  const { lineItems, intl, isCustomer } = props;

  const promoCode = lineItems.find(
    item => item.code === LINE_ITEM_PROMOCODE && !item.reversal
  );

  return promoCode && isCustomer ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.PromoCode" />
      </span>
      <span className={css.itemValue}>
        {formatMoney(intl, promoCode.lineTotal, true)}
      </span>
    </div>
  ) : null;
};

LineItemPromoCodeMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemPromoCodeMaybe;
